/* eslint-disable @typescript-eslint/no-empty-interface */
import styled from 'styled-components';
import { getLang, pxToRem, getAppView } from '@gif/shared-global';
import { MlbLogo as MlbLogoComponent } from '../../assets';

const lang = getLang();
const appView = getAppView();
const isApp = appView !== 'web';
const pathName = `${isApp ? `/${appView}` : ''}${
  lang !== 'en' ? `/${lang}` : ''
}`;

const defaultUrl = `https://www.mlb.com${pathName}`;
const defaultAltText = 'Major League Baseball';

const Hyperlink = styled.a`
  display: inline-block;
`;

const MlbLogo = styled(MlbLogoComponent)`
  height: ${pxToRem(40)};
`;

export interface MlbLogoLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  url?: string;
  altText?: string;
}

export const MlbLogoLink = (props: MlbLogoLinkProps) => {
  const { url = defaultUrl, altText = defaultAltText, ...rest } = props;
  return (
    <Hyperlink href={url} {...rest}>
      <MlbLogo title={altText} />
    </Hyperlink>
  );
};

export default MlbLogoLink;
